export default "__VITE_ASSET__BEeEoURy__"